import { readDemoLeadRef } from "../constants/demoMode";

const API = process.env.REACT_APP_BACKEND_URL || "http://localhost:8000";

/**
 * Envoie un événement de navigation démo (silencieux si échec).
 * Types autorisés : alignés sur backend ALLOWED_TRACK_EVENTS.
 */
export async function postDemoTrack(eventType, { path = null, detail = null } = {}) {
  if (!eventType) return;
  try {
    const lead_ref = readDemoLeadRef();
    const body = {
      event_type: eventType,
      lead_ref: lead_ref || undefined,
      path: path || (typeof window !== "undefined" ? window.location?.pathname : null),
      detail: detail && typeof detail === "object" ? detail : undefined,
    };
    await fetch(`${API}/api/demo/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
  } catch {
    /* silencieux — pas d’impact UX */
  }
}
